/** @jsxImportSource @emotion/react */
import React, { useContext, useState } from 'react'
import { css, useTheme } from '@emotion/react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import { ThemeUI } from '../../../theme'
import { Button, Card, Text } from '../../atoms'
import { ContentSection } from '../../organisms'
import * as styles from './index.styles'
import { Context } from "../../../context/PortofolioContext";
import { post_portofolio } from '../../../redux/actions/portofolio/post_portofolio';
import { put_portofolio } from '../../../redux/actions/portofolio/put_portofolio';
import { delete_portofolio } from '../../../redux/actions/portofolio/delete_portofolio';
//import { get_portofolio } from '../../../redux/actions/portofolio/get_portofolio';
import Modal from '../Modal/index';


const AboutUsPreview: React.FC = () => {
  const dispatch = useDispatch()
  const theme = useTheme() as ThemeUI
  const navigate = useNavigate();
  const { formData } = useContext(Context)
  const token = useSelector((state: any) => state.login.access)
  let { id } = useParams();
  const [showModal, setShowModal] = useState<boolean>(false)
  const [showModalDelete, setShowModalDelete] = useState<boolean>(false)


  const handleChange = (token: any, formData: any) => {
    if (id) {
      console.log(id)
      dispatch(put_portofolio({ id, token, data: formData, navigate }))
    } else {
      delete formData.id
      dispatch(post_portofolio({ token, data: formData, navigate }))
    }
  }


  const handleDelete = () => {
    dispatch(delete_portofolio({ id, token, data: formData, navigate }))
    //dispatch(get_banners({ lang: null, token }))
  }


  const successAction = () => {
    handleChange(token, formData)
    //dispatch(get_banners({ lang: null, token }))
  }

  const closeModal = () => {
    setShowModal(false)
  }

  const closeModalDelete = () => {
    setShowModalDelete(false)
  }


  return (
    <ContentSection
      style={styles.root}
      header={
        <Text textType='p' weight='bold'>Vista Previa</Text>
      }
    >
      <div css={(theme: any) => styles.preview(theme)}>
        <Card style={css({ overflow: 'hidden' })}>
          <Text textType='sm' style={styles.previewTitle(theme)}>
            {formData.title}
          </Text>
          <div css={styles.previewDescription(theme)}>
            <Text textType='sm' weight='light'>
              {formData.description}
            </Text>
            <Text textType='sm' weight='light'>
              {formData.lang}
            </Text>
          </div>
        </Card>
      </div>
      <Button onClick={() => {
        setShowModal(true)
      }} disabled={!formData.title || !formData.lang || !formData.description}>
        {!id ? 'Publicar' : 'Guardar'} Portafolio
      </Button>

      {
        id ?
          (
            <Modal
              show={showModal}
              title={'¿Esta seguro de modificar este portafolio?'}
              text={' '}
              onClickSuccess={successAction}
              onClickClose={closeModal}
              btnSuccess={'Si'}
              btnWarning={"No"}
              onClickWarning={closeModal} />
          ) :
          (
            <Modal
              show={showModal}
              title={'¿Esta seguro de publicar este portafolio?'}
              text={''}
              onClickSuccess={successAction}
              onClickClose={closeModal}
              btnSuccess={'Si'}
              btnWarning={"No"}
              onClickWarning={closeModal}
            />
          )
      }


      {id && (
        <>
          <Button onClick={() => {
            setShowModalDelete(true)
          }}>
            Eliminar Portafolio
          </Button>
          <Modal
            show={showModalDelete}
            title={'¿Esta seguro de eliminar este portafolio?'}
            text={' '}
            onClickSuccess={handleDelete}
            onClickClose={closeModalDelete}
            btnSuccess={'Si'}
            btnWarning={"No"}
            onClickWarning={closeModalDelete}
          />
        </>
      )}
    </ContentSection>
  )
}


export default AboutUsPreview;
